import {
  GLOBAL_CONTACTS_FILTERS,
  GLOBAL_CONTACTS_FILTERS_SEARCH,
  LIST_CONTACTS_FILTERS,
  LIST_CONTACTS_FILTERS_SEARCH,
} from 'constants/types/audienceTypesNew';
import { ContactsFiltersEnum, IContactsFiltersReducerAction, IContactsFiltersReducerStore } from '../interfaces2';

const contactsFiltersInitialState: IContactsFiltersReducerStore = {
  globalContactsFilters: {
    industries: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    revenue: {
      loading: false,
      data: [],
    },
    designations: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    organizations: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    buyerStages: {
      loading: false,
      data: [],
    },
    appliedFilters: {
      designation: [],
      organization: [],
      personalityType: [],
      status: [],
      buyerStage: [],
      industry: [],
      revenue: [],
    },
    selectedFilters: {
      designation: [],
      organization: [],
      personalityType: [],
      status: [],
      buyerStage: [],
      industry: [],
      revenue: [],
    },
  },
  listContactsFilters: {
    listId: '',
    industries: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    revenue: {
      loading: false,
      data: [],
    },
    designations: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    buyerStages: {
      loading: false,
      data: [],
    },
    organizations: {
      loading: false,
      data: [],
      searchedLoading: false,
      searchedData: [],
      searchTerm: '',
    },
    appliedFilters: {
      designation: [],
      organization: [],
      personalityType: [],
      status: [],
      buyerStage: [],
      industry: [],
      revenue: [],
    },
    selectedFilters: {
      designation: [],
      organization: [],
      personalityType: [],
      status: [],
      buyerStage: [],
      industry: [],
      revenue: [],
    },
  },
};

export const contactsFiltersReducerStore = (
  state: IContactsFiltersReducerStore = contactsFiltersInitialState,
  action: IContactsFiltersReducerAction,
) => {
  const newState = { ...state };
  switch (action.type) {
    case GLOBAL_CONTACTS_FILTERS.LOAD:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.globalContactsFilters.buyerStages.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.globalContactsFilters.revenue.loading = true;
      }
      return newState;
    case GLOBAL_CONTACTS_FILTERS.SUCCESS:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.loading = false;
        newState.globalContactsFilters.designations.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.loading = false;
        newState.globalContactsFilters.organizations.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.globalContactsFilters.buyerStages.loading = false;
        newState.globalContactsFilters.buyerStages.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.loading = false;
        newState.globalContactsFilters.industries.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.globalContactsFilters.revenue.loading = false;
        newState.globalContactsFilters.revenue.data = action.payload.data as string[];
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS.FAIL:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.globalContactsFilters.buyerStages.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.globalContactsFilters.revenue.loading = false;
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS.RESET:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.loading = false;
        newState.globalContactsFilters.designations.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.loading = false;
        newState.globalContactsFilters.organizations.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.globalContactsFilters.buyerStages.loading = false;
        newState.globalContactsFilters.buyerStages.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.loading = false;
        newState.globalContactsFilters.industries.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.globalContactsFilters.revenue.loading = false;
        newState.globalContactsFilters.revenue.data = [];
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.SET_SEARCH_TERM:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.searchTerm = action.payload.searchTerm as string;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.searchTerm = action.payload.searchTerm as string;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.searchTerm = action.payload.searchTerm as string;
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.LOAD:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.searchedLoading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.searchedLoading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.searchedLoading = true;
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.SUCCESS:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.searchedLoading = false;
        newState.globalContactsFilters.designations.searchedData = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.searchedLoading = false;
        newState.globalContactsFilters.organizations.searchedData = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.searchedLoading = false;
        newState.globalContactsFilters.industries.searchedData = action.payload.data as string[];
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.FAIL:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.searchedLoading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.searchedLoading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.searchedLoading = false;
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.RESET:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.designations.searchTerm = '';
        newState.globalContactsFilters.designations.searchedLoading = false;
        newState.globalContactsFilters.designations.searchedData = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.organizations.searchTerm = '';
        newState.globalContactsFilters.organizations.searchedLoading = false;
        newState.globalContactsFilters.organizations.searchedData = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.industries.searchTerm = '';
        newState.globalContactsFilters.industries.searchedLoading = false;
        newState.globalContactsFilters.industries.searchedData = [];
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.RESET_SELECTION:
      newState.globalContactsFilters.designations.searchTerm = '';
      newState.globalContactsFilters.designations.searchedLoading = false;
      newState.globalContactsFilters.designations.searchedData = [];
      newState.globalContactsFilters.organizations.searchTerm = '';
      newState.globalContactsFilters.organizations.searchedLoading = false;
      newState.globalContactsFilters.organizations.searchedData = [];
      newState.globalContactsFilters.industries.searchTerm = '';
      newState.globalContactsFilters.industries.searchedLoading = false;
      newState.globalContactsFilters.industries.searchedData = [];
      return newState;

    case GLOBAL_CONTACTS_FILTERS_SEARCH.SELECT_FILTER:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.selectedFilters.designation = action.payload.filter as string[];
        if (!newState.globalContactsFilters.designations.data.includes(action.payload.filterItem as string)) {
          newState.globalContactsFilters.designations.data = [
            action.payload.filterItem as string,
            ...newState.globalContactsFilters.designations.data,
          ];
        }
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.selectedFilters.organization = action.payload.filter as string[];
        if (!newState.globalContactsFilters.organizations.data.includes(action.payload.filterItem as string)) {
          newState.globalContactsFilters.organizations.data = [
            action.payload.filterItem as string,
            ...newState.globalContactsFilters.organizations.data,
          ];
        }
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.selectedFilters.revenue = action.payload.filter as string[];
        if (!newState.globalContactsFilters.revenue.data.includes(action.payload.filterItem as string)) {
          newState.globalContactsFilters.revenue.data = [
            action.payload.filterItem as string,
            ...newState.globalContactsFilters.revenue.data,
          ];
        }
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS.SELECT_FILTER:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.globalContactsFilters.selectedFilters.designation = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.globalContactsFilters.selectedFilters.organization = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.PersonalityType) {
        newState.globalContactsFilters.selectedFilters.personalityType = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Status) {
        newState.globalContactsFilters.selectedFilters.status = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.globalContactsFilters.selectedFilters.buyerStage = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.globalContactsFilters.selectedFilters.industry = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.globalContactsFilters.selectedFilters.revenue = action.payload.filter as string[];
      }
      return newState;

    case GLOBAL_CONTACTS_FILTERS.APPLY_FILTERS:
      newState.globalContactsFilters.appliedFilters.designation =
        newState.globalContactsFilters.selectedFilters.designation;
      newState.globalContactsFilters.appliedFilters.organization =
        newState.globalContactsFilters.selectedFilters.organization;
      newState.globalContactsFilters.appliedFilters.personalityType =
        newState.globalContactsFilters.selectedFilters.personalityType;
      newState.globalContactsFilters.appliedFilters.status = newState.globalContactsFilters.selectedFilters.status;
      newState.globalContactsFilters.appliedFilters.buyerStage =
        newState.globalContactsFilters.selectedFilters.buyerStage;
      newState.globalContactsFilters.appliedFilters.industry = newState.globalContactsFilters.selectedFilters.industry;
      newState.globalContactsFilters.appliedFilters.revenue = newState.globalContactsFilters.selectedFilters.revenue;
      // if (action.payload.filterType === ContactsFiltersEnum.Designations) {
      // } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
      //   newState.globalContactsFilters.appliedFilters.organization = newState.globalContactsFilters.selectedFilters.organization;
      // }
      return newState;

    case GLOBAL_CONTACTS_FILTERS.RESET_SELECTION:
      newState.globalContactsFilters.selectedFilters.organization = [];
      newState.globalContactsFilters.selectedFilters.designation = [];
      newState.globalContactsFilters.selectedFilters.personalityType = [];
      newState.globalContactsFilters.selectedFilters.status = [];
      newState.globalContactsFilters.selectedFilters.buyerStage = [];
      newState.globalContactsFilters.selectedFilters.industry = [];
      newState.globalContactsFilters.selectedFilters.revenue = [];
      newState.globalContactsFilters.appliedFilters.organization = [];
      newState.globalContactsFilters.appliedFilters.designation = [];
      newState.globalContactsFilters.appliedFilters.personalityType = [];
      newState.globalContactsFilters.appliedFilters.status = [];
      newState.globalContactsFilters.appliedFilters.buyerStage = [];
      newState.globalContactsFilters.appliedFilters.industry = [];
      newState.globalContactsFilters.appliedFilters.revenue = [];
      // if (action.payload.filterType === ContactsFiltersEnum.Designations) {
      //   newState.globalContactsFilters.selectedFilters.designation = [];
      // } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
      //   newState.globalContactsFilters.selectedFilters.organization = [];
      // }
      return newState;

    //* List Contacts Filters

    case LIST_CONTACTS_FILTERS.SET_LIST_ID:
      newState.listContactsFilters.listId = action.payload.listId as string;
      return newState;

    case LIST_CONTACTS_FILTERS.LOAD:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.listContactsFilters.buyerStages.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.buyerStages.loading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.buyerStages.loading = true;
      }
      return newState;
    case LIST_CONTACTS_FILTERS.SUCCESS:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.loading = false;
        newState.listContactsFilters.designations.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.loading = false;
        newState.listContactsFilters.organizations.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.listContactsFilters.buyerStages.loading = false;
        newState.listContactsFilters.buyerStages.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.loading = false;
        newState.listContactsFilters.industries.data = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.loading = false;
        newState.listContactsFilters.revenue.data = action.payload.data as string[];
      }
      return newState;

    case LIST_CONTACTS_FILTERS.FAIL:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.listContactsFilters.buyerStages.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.loading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.loading = false;
      }
      return newState;

    case LIST_CONTACTS_FILTERS.RESET:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.loading = false;
        newState.listContactsFilters.designations.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.loading = false;
        newState.listContactsFilters.organizations.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.listContactsFilters.buyerStages.loading = false;
        newState.listContactsFilters.buyerStages.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.loading = false;
        newState.listContactsFilters.industries.data = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.loading = false;
        newState.listContactsFilters.revenue.data = [];
      }
      return newState;

    case LIST_CONTACTS_FILTERS.RESET_ALL:
      newState.listContactsFilters.designations.loading = false;
      newState.listContactsFilters.designations.data = [];
      newState.listContactsFilters.organizations.loading = false;
      newState.listContactsFilters.organizations.data = [];
      newState.listContactsFilters.industries.loading = false;
      newState.listContactsFilters.industries.data = [];
      newState.listContactsFilters.revenue.loading = false;
      newState.listContactsFilters.revenue.data = [];
      return newState;

    case LIST_CONTACTS_FILTERS.SELECT_FILTER:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.selectedFilters.designation = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.selectedFilters.organization = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.PersonalityType) {
        newState.listContactsFilters.selectedFilters.personalityType = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Status) {
        newState.listContactsFilters.selectedFilters.status = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.BuyerStage) {
        newState.listContactsFilters.selectedFilters.buyerStage = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.selectedFilters.industry = action.payload.filter as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.selectedFilters.revenue = action.payload.filter as string[];
      }
      return newState;

    case LIST_CONTACTS_FILTERS.APPLY_FILTERS:
      newState.listContactsFilters.appliedFilters.designation =
        newState.listContactsFilters.selectedFilters.designation;
      newState.listContactsFilters.appliedFilters.organization =
        newState.listContactsFilters.selectedFilters.organization;
      newState.listContactsFilters.appliedFilters.personalityType =
        newState.listContactsFilters.selectedFilters.personalityType;
      newState.listContactsFilters.appliedFilters.status = newState.listContactsFilters.selectedFilters.status;
      newState.listContactsFilters.appliedFilters.buyerStage = newState.listContactsFilters.selectedFilters.buyerStage;
      newState.listContactsFilters.appliedFilters.industry = newState.listContactsFilters.selectedFilters.industry;
      newState.listContactsFilters.appliedFilters.revenue = newState.listContactsFilters.selectedFilters.revenue;
      // if (action.payload.filterType === ContactsFiltersEnum.Designations) {
      //   newState.listContactsFilters.appliedFilters.designation = newState.listContactsFilters.selectedFilters.designation;
      // } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
      //   newState.listContactsFilters.appliedFilters.organization = newState.listContactsFilters.selectedFilters.organization;
      // }
      return newState;

    case LIST_CONTACTS_FILTERS.RESET_SELECTION:
      newState.listContactsFilters.selectedFilters.organization = [];
      newState.listContactsFilters.selectedFilters.designation = [];
      newState.listContactsFilters.selectedFilters.personalityType = [];
      newState.listContactsFilters.selectedFilters.status = [];
      newState.listContactsFilters.selectedFilters.buyerStage = [];
      newState.listContactsFilters.selectedFilters.industry = [];
      newState.listContactsFilters.selectedFilters.revenue = [];
      newState.listContactsFilters.appliedFilters.organization = [];
      newState.listContactsFilters.appliedFilters.designation = [];
      newState.listContactsFilters.appliedFilters.personalityType = [];
      newState.listContactsFilters.appliedFilters.status = [];
      newState.listContactsFilters.appliedFilters.buyerStage = [];
      newState.listContactsFilters.appliedFilters.industry = [];
      newState.listContactsFilters.appliedFilters.revenue = [];
      // if (action.payload.filterType === ContactsFiltersEnum.Designations) {
      // } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
      //   newState.listContactsFilters.selectedFilters.organization = [];
      //   newState.listContactsFilters.appliedFilters.organization = [];
      // }
      return newState;

    case LIST_CONTACTS_FILTERS_SEARCH.LOAD:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.searchedLoading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.searchedLoading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.searchedLoading = true;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.searchedLoading = true;
      }
      return newState;

    case LIST_CONTACTS_FILTERS_SEARCH.SUCCESS:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.searchedLoading = false;
        newState.listContactsFilters.designations.searchedData = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.searchedLoading = false;
        newState.listContactsFilters.organizations.searchedData = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.searchedLoading = false;
        newState.listContactsFilters.industries.searchedData = action.payload.data as string[];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.searchedLoading = false;
        newState.listContactsFilters.revenue.searchedData = action.payload.data as string[];
      }
      return newState;

    case LIST_CONTACTS_FILTERS_SEARCH.FAIL:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.searchedLoading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.searchedLoading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.searchedLoading = false;
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.searchedLoading = false;
      }
      return newState;

    case LIST_CONTACTS_FILTERS_SEARCH.RESET:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.designations.searchTerm = '';
        newState.listContactsFilters.designations.searchedLoading = false;
        newState.listContactsFilters.designations.searchedData = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.organizations.searchTerm = '';
        newState.listContactsFilters.organizations.searchedLoading = false;
        newState.listContactsFilters.organizations.searchedData = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.industries.searchTerm = '';
        newState.listContactsFilters.industries.searchedLoading = false;
        newState.listContactsFilters.industries.searchedData = [];
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.revenue.searchTerm = '';
        newState.listContactsFilters.revenue.searchedLoading = false;
        newState.listContactsFilters.revenue.searchedData = [];
      }
      return newState;

    case LIST_CONTACTS_FILTERS_SEARCH.SELECT_FILTER:
      if (action.payload.filterType === ContactsFiltersEnum.Designations) {
        newState.listContactsFilters.selectedFilters.designation = action.payload.filter as string[];
        if (!newState.listContactsFilters.designations.data.includes(action.payload.filterItem as string)) {
          newState.listContactsFilters.designations.data = [
            action.payload.filterItem as string,
            ...newState.listContactsFilters.designations.data,
          ];
        }
      } else if (action.payload.filterType === ContactsFiltersEnum.Organizations) {
        newState.listContactsFilters.selectedFilters.organization = action.payload.filter as string[];
        if (!newState.listContactsFilters.organizations.data.includes(action.payload.filterItem as string)) {
          newState.listContactsFilters.organizations.data = [
            action.payload.filterItem as string,
            ...newState.listContactsFilters.organizations.data,
          ];
        }
      } else if (action.payload.filterType === ContactsFiltersEnum.Industry) {
        newState.listContactsFilters.selectedFilters.industry = action.payload.filter as string[];
        if (!newState.listContactsFilters.industries.data.includes(action.payload.filterItem as string)) {
          newState.listContactsFilters.industries.data = [
            action.payload.filterItem as string,
            ...newState.listContactsFilters.industries.data,
          ];
        }
      } else if (action.payload.filterType === ContactsFiltersEnum.Revenue) {
        newState.listContactsFilters.selectedFilters.revenue = action.payload.filter as string[];
        if (!newState.listContactsFilters.revenue.data.includes(action.payload.filterItem as string)) {
          newState.listContactsFilters.revenue.data = [
            action.payload.filterItem as string,
            ...newState.listContactsFilters.revenue.data,
          ];
        }
      }
      return newState;

    default:
      return newState;
  }
};
